import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Wrapper, Title, Inputs, Name, Phone, ButtonBlock, Button, OrAuth, Agree, Message } from './styled';
import useSubmit from './hooks/useSubmit';
import { dataLayerForCBPhonePush } from '~/src/helpers/eventsForDataLayer';
import { ACTIONS } from '~/src/constants/analytics';

const AuthForm = (props) => {
    const {
        title = 'Чтобы подключить услугу, станьте клиентом Дом.ru или авторизуйтесь',
        buttonText = 'Стать клиентом',
        textColor,
        cityDomain,
        handleSuccess,
        getParams = '',
        handleAuthClick,
        isPopup = false,
        onlyBecomeClient = false,
        disableButton = false,
        option,
    } = props;

    const [phone, setPhone] = useState({});
    const [name, setName] = useState({});
    const [isValidInputs, setIsValidInputs] = useState(false);
    const [beenStarted, setDataLayer] = useState(false);

    useEffect(() => {
        setIsValidInputs(phone.isValid && name.isValid);
    }, [phone, name]);

    const [{ status, isLoading, message }, doSubmit] = useSubmit(cityDomain, isPopup);

    const onChangeHandler = (stateInput, _setState) => {
        // @TODO stateInput.value убрать из условия после фикса nameDecorator (useEffect onchange) UI react
        if (!beenStarted && stateInput.value !== undefined) {
            dataLayerForCBPhonePush({
                action: ACTIONS.started,
                isPopup,
                requestId: null,
                option: option ?? '',
            });
            setDataLayer(true);
        }
        _setState(stateInput);
    };

    const submitHandler = e => {
        e.preventDefault();
        if (isValidInputs) {
            const params = {
                name: name.value,
                phone: phone.value,
                label: option,
            };

            if (handleSuccess) {
                handleSuccess(params);
            } else {
                doSubmit(params);
            }
        }
    };

    return (
        <Wrapper onSubmit={submitHandler}>
            {
                status && message
                    ? <Message>{message}</Message>
                    : <>
                        <Title>
                            {title}
                        </Title>
                        <Inputs>
                            <Name
                                name='name'
                                onChange={(stateInput) => onChangeHandler(stateInput, setName)}
                                placeholder='Как вас зовут?'
                                errorMessage='Ожидаются только буквы и дефисы'
                            />
                            <Phone
                                name='phone'
                                onChange={(stateInput) => onChangeHandler(stateInput, setPhone)}
                                placeholder='Номер телефона'
                                errorMessage='Введите телефон в формате +7 (999) 999-99-99'
                            />
                        </Inputs>
                        <ButtonBlock>
                            <Button text={buttonText} disabled={!isValidInputs || isLoading || disableButton}/>
                            {onlyBecomeClient
                                ? <Agree textColor={textColor}>
                                    Нажимая на кнопку, вы даёте согласие на&nbsp;обработку&nbsp;
                                    <a href='https://dom.ru/policy.pdf?_ga=2.194887981.1682807258.1580735380-296976907.1577435201' target='_blank' rel='noreferrer'>
                                        персональных данных
                                    </a>
                                </Agree>
                                : <OrAuth>
                                    или&nbsp;
                                    <a href={`/user/login${getParams}`} onClick={handleAuthClick}>авторизоваться</a>
                                </OrAuth>
                            }
                        </ButtonBlock>
                        {!onlyBecomeClient && <Agree textColor={textColor}>
                            Нажимая на кнопку, вы даёте согласие на&nbsp;обработку&nbsp;
                            <a href='https://dom.ru/policy.pdf?_ga=2.194887981.1682807258.1580735380-296976907.1577435201' target='_blank' rel='noreferrer'>
                                персональных данных
                            </a>
                        </Agree>}
                    </>
            }
        </Wrapper>
    );
};

const mapStateToProps = state => ({
    cityDomain: state.city.currentCity.domain,
});

export default connect(mapStateToProps)(AuthForm);
